import { useAddReactionMutation } from '@/features/reactions/graphql/mutations/generated/addReaction';
import { useRemoveReactionMutation } from '@/features/reactions/graphql/mutations/generated/removeReaction';

export default function useReaction() {
  const [, addReaction] = useAddReactionMutation();
  const [, removeReaction] = useRemoveReactionMutation();

  return { addReaction, removeReaction };
}
